import { d as d$1 } from './chunk-6EFRS222.mjs';
import { b } from './chunk-26IU2X5T.mjs';
import n from 'styled-components';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation';
import { jsxs, jsx } from 'react/jsx-runtime';

var a=n(d$1).attrs({forwardedAs:"p"})`
  ${r=>r.$variant==="helper"&&"color: var(--foreground-secondary);"}
  ${r=>r.$variant==="error"&&"color: var(--foreground-inline-error);"}
`,p=n(b)`
  ${r=>r.$variant==="error"&&"color: var(--foreground-inline-error);"}
  padding-right: var(--spacing-small);
  font-size: var(--icon-size-regular);
`;var c=({variant:r="helper",icon:e,children:s,className:i,...m})=>jsxs(a,{$variant:r,className:i,...m,children:[(e!=null?e:r==="error")&&jsx(p,{icon:e!=null?e:faCircleExclamation}),s]}),d=n(c)``;

export { d as a };
